// src/applicants/ApplicantInterviewsModal.js
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { VideoCall as VideoCallIcon } from '@mui/icons-material';
import ApplicantInterviews from './ApplicantInterviews';
import { useTranslation } from 'react-i18next';

const ApplicantInterviewsModal = ({ open, onClose, applicant }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <VideoCallIcon color="primary" />
          {t('interviews.modalTitle', { name: applicant?.name })}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ApplicantInterviews applicant={applicant} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicantInterviewsModal;